<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid upload-container p-3">

    <div class="row">
      <div class="col px-0">
        <div class="select_container" style="float:left">
          <select class="form-control" v-bind:id="'select_' +  getId()" data-fouc v-on:change="onChange" v-select>
            <option value="" style="">{{placeholder}}</option>
            <option v-for="option in teams" v-bind:value="option.Id">
              {{ option.Name }}
            </option>
          </select>
        </div>


        <button type="button" class="btn btn-outline bg-primary text-primary-800 btn-icon ml-1" @click="displayForm" style="float:right"><i class="icon-plus3"></i></button>

      </div>
    </div>

    <div class="row">
      <div class="input-container col-sm-12 px-0" v-if="displayAdd == true" style="float:left;">
        <input type="text" v-bind:placeholder="$t('team_name')" class="form-control" v-model="teamName">
      </div>

      <div class="text-right col-sm-12 px-0" v-if="displayAdd == true" style="float:right;">
        <button type="submit" class="btn skin primary-button mt-1" @click="createTeam">{{buttontext}}</button>
      </div>
    </div>


    <div v-if="message != null && message != ''" class="col-12 alert alert-light upload-error-message" role="alert">
      <ul>
        <li class="col-12" v-for="(ms, i) in message.split('\n')" :key="i">
          {{ ms }}
        </li>
      </ul>
    </div>

  </div>
</template>

<script>


  let message = "";
  let displayAdd = false;
  var teams = [];
  var teamName = "";
  var placeholder = "";
  var buttontext = "";

  export default {
    name: "team-selector",
    props: {
      
      value: {
        type: String,
        default: null
      },
    },
    data() {
      return {
        placeholder,
        buttontext,
        message: "",
        visible: this.visibility,
        displayAdd,
        teamName,
        teams
      };
    },
    methods: {
      displayForm() {
        this.displayAdd = !this.displayAdd;
      },
      getOptionStyle(v) {
        return v;
      },
      onChange() {
        this.$emit('change', $("#" + 'select_' + this.getId()).val());
      },
      input(event) {
      },
      getId() {
        return this._uid;
      },
      doChange() {
      },
      async createTeam() {
        var request = { name: this.teamName };
        try {
          var response = await this.$http.post(
            '/api/Team/Create',
            request
          ).then(async response => {
            this.loadTeams(response.data.Id);
            this.displayAdd = false;
          });

        } catch (err) {
          alert(err);
        }
      },
      async deleteTeam(id) {
        try {
          this.teams = [];
          this.$http.get('/api/Team/Delete?id='+ id).then(async response => {
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async loadTeams(selected) {
        try {
          this.teams = [];
          this.$http.get('/api/Teams/v1?').then(async response => {

            this.teams = response.data;
            $('#' + 'select_' + this.getId()).select2();

          }).then((async response => {
            if (selected != null) {
              $("#select_" + this.getId()).val(selected);
              $("#select_" + this.getId()).trigger('change');
            }
          }
          ));
        } catch (err) {
          alert('some error:' + err)
        }
      },
      getData() {
        return this.teams;
      }
    },
    watch: {
      value: function (newVal, oldVal) {
        $("#select_" + this.getId()).val(newVal);
        $("#select_" + this.getId()).trigger('change');
      }
    },
    mounted() {
      this.loadTeams(this.value);
      $("#select_" + this.getId()).change(this.onChange);
      this.placeholder = this.$store.translate('select_team');
      this.buttontext = this.$store.translate('add_team');
     

    }
  };
</script>

<style scoped>
  .select_container {
    width: calc(100%)
  }
</style>




// WEBPACK FOOTER //
// src/components/team/team-selector.vue